import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Progress } from "./ui/progress";
import { HeartPulse } from "lucide-react";
import { AdSlot, ADSENSE_ON } from "./AdSlot";

const AD_SECONDS = 5;

// Real AdSense unit when configured, demo placeholder otherwise
export const AdModal = ({ t, open, onDone }) => {
  const [left, setLeft] = useState(AD_SECONDS);
  useEffect(() => {
    if (!open) return;
    setLeft(AD_SECONDS);
    const id = setInterval(() => setLeft((l) => Math.max(0, l - 1)), 1000);
    return () => clearInterval(id);
  }, [open]);
  return (
    <Dialog open={open}>
      <DialogContent aria-describedby={undefined} data-testid="ad-modal" className="border-slate-200 bg-white text-slate-800 [&>button]:hidden">
        <DialogTitle className="label">{t("adTitle")}</DialogTitle>
        {ADSENSE_ON ? (
          <div className="relative mt-2 overflow-hidden rounded-xl border border-slate-200 bg-gradient-to-br from-teal-50 to-sky-50">
            <div className="absolute inset-0 grid place-items-center" aria-hidden><HeartPulse className="text-teal-700/40" size={40} /></div>
            <div className="relative"><AdSlot /></div>
          </div>
        ) : (
          <div className="mt-2 overflow-hidden rounded-xl border border-slate-200 bg-gradient-to-br from-teal-50 to-sky-50 p-6" data-testid="ad-placeholder">
            <HeartPulse className="text-teal-700" size={32} />
            <p className="font-display mt-4 text-2xl font-bold">VitaBalance Omega-3</p>
            <p className="mt-1 text-sm text-slate-600">Sponsor demo · ad placeholder</p>
          </div>
        )}
        <p className="mt-2 text-sm text-slate-500">{t("adPreparing")}</p>
        <Progress value={((AD_SECONDS - left) / AD_SECONDS) * 100} className="h-1.5" />
        <p className="text-xs text-slate-500">{t("adFree")}</p>
        <div><button data-testid="ad-continue-btn" disabled={left > 0} onClick={onDone} className="btn-primary w-full">
          {left > 0 ? `${t("adWait")} ${left}s` : t("adContinue")}
        </button></div>
      </DialogContent>
    </Dialog>
  );
};
